<template>
  <b-modal
    id="modal-scrollable"
    v-model="$store.state.someVariables.showMultas"
    scrollable
    no-close-on-backdrop
    title="Multas y Sanciones Equipos"
  >
    <b-tabs>
      <b-tab :title="dataPartido.local" @click="emitChange('local')">
        <content-tab-multa
          :listMultas="listMultas"
          :listMotivos="listMotivos"
          :dataPartido="dataPartido"
          :categoriaSeleccionada="categoriaSeleccionada"
          :idEquipo="dataPartido.id_local"
        ></content-tab-multa>
      </b-tab>
      <b-tab :title="dataPartido.visita" @click="emitChange('visita')">
        <content-tab-multa
          :listMultas="listMultas"
          :listMotivos="listMotivos"
          :dataPartido="dataPartido"
          :categoriaSeleccionada="categoriaSeleccionada"
          :idEquipo="dataPartido.id_visita"
        ></content-tab-multa>
      </b-tab>
    </b-tabs>
    <span></span>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-center">
        <b-badge variant="danger" class="badge-glow total">
          Total: {{ totalPagar }} $
        </b-badge>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal,
  BTabs,
  BTab,
  //   BRow,
  //   BCol,
  //   BButton,
  BBadge,
  //   BFormInput,
  //   BFormTextarea,
  //   BFormSpinbutton,
  //   BOverlay,
  //   BDropdownForm,
  //   BFormGroup,
  //   BDropdown,
  //  xxx,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { computed } from '@vue/composition-api'
import contentTabMulta from './ConctentTabMulta.vue'

export default {
  components: {
    BModal,
    BTabs,
    BTab,
    contentTabMulta,
    // BRow,
    // BCol,
    // BButton,
    BBadge,
    // BFormInput,
    // BFormTextarea,
    // BFormSpinbutton,
    // BOverlay,
    // BDropdownForm,
    // BFormGroup,
    // BDropdown,
  },
  props: {
    listMultas: Array,
    listMotivos: Array,
    dataPartido: Object,
    categoriaSeleccionada: Object,
    idEquipo: String,
  },
  directives: {
    Ripple,
  },
  setup(props, { emit }) {
    function emitChange(tipo) {
      // console.log('hola mundo')
      emit('changeEquipo', tipo)
    }

    function calculaTotal() {
      let total = 0
      props.listMultas.forEach(element => {
        total += Number(element.v_total)
      })
      return total.toFixed(2)
    }
    const totalPagar = computed(() => calculaTotal())

    return {
      totalPagar,
      emitChange,
    }
  },
}
</script>
<style>
.total {
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
}
.cabecera {
  font-size: 10px;
  font-weight: bold;
  background-color: #ececec;
  color: whi;
  padding: 3px;
}
</style>
